export default __webpack_public_path__ + "static/media/ag_4.fd9ba93b.wav";